import { useMemo } from 'react';

import config from 'config';

import { useDomain } from '~/techstyle-shared/redux-core';

export default function useLocalizedConfig(
  configPath,
  options = { tld: null }
) {
  const domain = useDomain();

  const key = useMemo(() => {
    const tld = options.tld ?? domain.tld;
    const localizedConfig = config.get(configPath);

    return localizedConfig?.[tld] ?? '';
  }, [configPath, domain, options]);

  return key;
}
